<template>
  <div v-if="showModal" class="content">
    <div class="modal overflow">
      <slot name="title"> </slot>
      <slot name="body"> </slot>
      <slot name="politica"> </slot>
      <slot name="check"> </slot>
      <slot name="footer"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showModal: {
      type: [Boolean, Number],
      default: false  
    },
    overflow: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  width: 90%;
  height: 80%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: white;
  text-align: justify;
  padding: 2% 5% 2% 5%;
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 20px 0px #424242; 
  box-shadow: 0px 0px 20px 0px #424242;
  background-color: #fcf9f9;
}
.overflow {
  overflow-y: auto;
}
.content {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  z-index: 9999 !important;
}

.modal-politica{
  width: 100%;
}

.modal-footer{
  width: 80%;
  display: flex;
  justify-content: space-around;
}

.modal-check{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>